import { connect } from 'react-redux'
import NewExpensesComponent from '../../components/expenses/expenses.component'
import {
  closeWarnAllowInvoiceSnackbar,
  closeWarnExpInvoiceSnackbar,
  showExpenseDialog,
  cancelExpenseDialog,
  showAllowanceDialog,
  cancelAllowanceDialog,
  cancelInvoiceInfoDialog,
  getInvoicesStart,
  getExpenseStart,
  expensePageChange,
  allowancePageChange,
  getAdminUsersList,
  addExpensesToInvoice,
  updateInvoiceIdToExpense,
  addAllowancesToInvoice,
  updateInvoiceIdToAllowance,
  loadAllowanceCost,
  getUserCompanyUpdateInfo,
  editAllowance,
  editExpense,
  closeExpenseSnackBar
} from '../../actions/index'

/**
 * The high order container for the expense component
 * @author  Pragya Gupta
 */

// To be called every time when the store is updated
const mapStateToProps = (state) => {
  const { client } = state
  const userType = client.user.data[5]

  const { adminUser } = state
  const { selectedUser } = adminUser

  return {
    user: state.oidc.user,
    // expenseRow: state.expense.expenseRow,
    expenses: state.expense.expenses,
    expensePages: Math.ceil(state.expense.expenses.length / 10),
    selectedExpensePage: state.expense.expenseSelected,
    // allowanceRow: state.expense.allowanceRow,
    allowances: state.expense.allowances,
    allowancePages: Math.ceil(state.expense.allowances.length / 10),
    selectedAllowancePage: state.expense.allowanceSelected,
    showWarnExpInvoiceSnackbar: state.expense.showWarnExpInvoiceSnackbar,
    showExpInvoiceSnackbar: state.expense.showExpInvoiceSnackbar,
    showAllowInvoiceSnackbar: state.expense.showAllowInvoiceSnackbar,
    showWarnAllowInvoiceSnackbar: state.expense.showWarnAllowInvoiceSnackbar,
    userType,
    selectedUser,
    showExpDialog: state.expense.showExpDialog,
    showTravelDialog: state.expense.showTravelDialog,
    showInvoiceInfoSuccess: state.expense.showInvoiceInfoSuccess,
    showInvoiceInfoFailed: state.expense.showInvoiceInfoFailed,
    isSaveAllowance: state.expense.isSaveAllowance,
    showSnackbar: state.expense.showSnackbar,
    showFailSnackbar: state.expense.showFailSnackbar,
    errMessage: state.expense.errMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    loadAllowanceCost: (year) => dispatch(loadAllowanceCost(year)),
    getInvoicesStart: (data) => dispatch(getInvoicesStart(data)),
    getExpenseStart: (data) => dispatch(getExpenseStart(data)),
    expensePageChange: (selected) => dispatch(expensePageChange(selected)),
    allowancePageChange: (selected) => dispatch(allowancePageChange(selected)),
    showExpenseDialog: (selected) => dispatch(showExpenseDialog(selected)),
    cancelExpenseDialog: () => dispatch(cancelExpenseDialog()),
    showAllowanceDialog: (selected) => dispatch(showAllowanceDialog(selected)),
    cancelAllowanceDialog: () => dispatch(cancelAllowanceDialog()),
    cancelInvoiceInfoDialog: () => dispatch(cancelInvoiceInfoDialog()),
    closeWarnExpInvoiceSnackbar: () => dispatch(closeWarnExpInvoiceSnackbar()),
    closeWarnAllowInvoiceSnackbar: () =>
      dispatch(closeWarnAllowInvoiceSnackbar()),
    getAdminUsersList: () => dispatch(getAdminUsersList()),
    addExpensesToInvoice: (expenses, formValues) =>
      dispatch(addExpensesToInvoice(expenses, formValues)),
    updateInvoiceIdToExpense: (invoice_id, option, selected) =>
      dispatch(updateInvoiceIdToExpense(invoice_id, option, selected)),
    addAllowancesToInvoice: (allowances, formValues) =>
      dispatch(addAllowancesToInvoice(allowances, formValues)),
    updateInvoiceIdToAllowance: (invoice_id, option, selected) =>
      dispatch(updateInvoiceIdToAllowance(invoice_id, option, selected)),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo()),
    editAllowance: (index, id) => dispatch(editAllowance(index, id)),
    editExpense: (index, invoice_expense_id) =>
      dispatch(editExpense(index, invoice_expense_id)),
    closeSnackbar: () => dispatch(closeExpenseSnackBar())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const NewExpensesComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NewExpensesComponent)

export default NewExpensesComponentContainer
